angular.module('shared').directive('ngDebounceClick', function ($timeout, $parse) {
    return {
        restrict: 'A',
        compile: function ($element, attr) {
            let ngDebounceOptions = attr['ngDebounceOptions'] ? $parse(attr['ngDebounceOptions'])() : {time: 500};
            var timeout;
            var fn = $parse(attr['ngDebounceClick'], /* interceptorFn */ null, /* expensiveChecks */ true);
            return function ngEventHandler(scope, element) {
                element.on('click', function (event) {
                    $timeout.cancel(timeout);
                    timeout = $timeout(function () {
                        var callback = function () {
                            fn(scope, {$event: event});
                        };
                        scope.$apply(callback);
                    }, ngDebounceOptions.time)
                });
            };
        }
    }
});
